"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_alexa__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ece26aee-6c11-4792-98eb-3392dd144aff",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2c1c8912-5fa0-41ba-a12b-077d18998b8c",
    x1: 56,
    y1: 96,
    x2: 136,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("title", null, "alexa-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "c40eedac-a3a8-4275-b456-0528c414ce69",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,176H70a14,14,0,0,1-14-14V30A14,14,0,0,1,70,16h52a14,14,0,0,1,14,14V162A14,14,0,0,1,122,176Z",
    transform: "translate(0 0)",
    fill: "url(#2c1c8912-5fa0-41ba-a12b-077d18998b8c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,174H70a14,14,0,0,1-14-14v2a14,14,0,0,0,14,14h52a14,14,0,0,0,14-14v-2A14,14,0,0,1,122,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40.08,
    width: 80,
    height: 2.42
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35.92,
    width: 80,
    height: 4.16,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "3ce5cfff-ca49-4b78-9e65-9755b758d8a7",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 136,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 124,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132,136a4,4,0,0,0,4,4v-8A4,4,0,0,0,132,136Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,136a4,4,0,0,0-4-4v8A4,4,0,0,0,60,136Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 112,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132,112a4,4,0,0,0,4,4v-8A4,4,0,0,0,132,112Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,112a4,4,0,0,0-4-4v8A4,4,0,0,0,60,112Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,110a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,88,110Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,110a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,120,110Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,110a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,104,110Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,110a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,72,110Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,122a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,64,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,122a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,80,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,122a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,96,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,122a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,112,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,122a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,128,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,112a4.09,4.09,0,0,0,.14,1,4,4,0,0,1,3.86-3v-2A4,4,0,0,0,132,112Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.86,113a4.09,4.09,0,0,0,.14-1,4,4,0,0,0-4-4v2A4,4,0,0,1,59.86,113Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,134a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,88,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,134a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,120,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,134a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,104,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,134a4,4,0,0,1,3.86,3,4.09,4.09,0,0,0,.14-1,4,4,0,0,0-8,0,4.09,4.09,0,0,0,.14,1A4,4,0,0,1,72,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,136a4.09,4.09,0,0,0,.14,1,4,4,0,0,1,3.86-3v-2A4,4,0,0,0,132,136Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.86,137a4.09,4.09,0,0,0,.14-1,4,4,0,0,0-4-4v2A4,4,0,0,1,59.86,137Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })));
}

var _default = ic_alexa__dark;
exports.default = _default;